import { render, staticRenderFns } from "./EventBlockFormCriterion.vue?vue&type=template&id=56ba4790&"
import script from "./EventBlockFormCriterion.vue?vue&type=script&lang=js&"
export * from "./EventBlockFormCriterion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports